import { attrs, withDefaults } from "./helpers.js";

/** @type {import("@warp-drive/core/types/schema/fields").LegacyResourceSchema} */
export const TagSettingsSchema = withDefaults({
  type: "tag-settings",
  fields: [
    ...attrs(
      "name",
      "locale",
      "slug",
      "description",
      "synonyms",
      "tag_group_names",
      "tag_groups",
      "category_restricted",
      "can_edit",
      "can_admin",
      "categories",
      "localizations"
    ),
  ],
});
